enum SearchFilters {
	Identification = 'identificacion',
	Email = 'email',
}

export default SearchFilters;
